
import React from "react";
import { Panel } from "primereact/panel";
import { PartnerDto } from "../../../../../partners/domain";
import { tawreedTranslationService } from "../../../../../../common/translations";
import { setFocus, TawreedFormField, TawreedInputText } from "../../../../../../common";
import { PartnerAutoCompleteComponent } from "../../../../../partners";
import { PartnerType } from "../../../../../partners/data";

export interface FormCustomerProps {
    className?: string;
    initial?: PartnerDto;
    onSelect: (p: PartnerDto) => void;
    disabled: boolean;
}


export const FormCustomer: React.FC<FormCustomerProps> = (props) => {
    return (
        <Panel header={tawreedTranslationService.translate('lbl_sales_cart_customer_information')} className="col-12">
            <div className="grid">
                <TawreedFormField className="field col-12 md:col-6" name="customer" title="lbl_sales_carts_customer_partner_name">
                    <PartnerAutoCompleteComponent partnerType={PartnerType.Customer}
                        active={true}
                        autoCompleteName="customer"
                        autoCompleteRules={{ required: 'msg_field_is_required' }}
                        autoCompleteField="partnerName"
                        autoCompleteOnSelect={e => {
                            props.onSelect(e.value);
                            setFocus('storeProduct');
                        }}
                        autoCompleteDisabled={props.disabled}
                        autoCompleteRender="form" />
                </TawreedFormField>

                <TawreedFormField className="field col-12 md:col-6" name="mobileNo" title="lbl_partners_contact_mobile">
                    <TawreedInputText render="standalone" value={props.initial?.contact?.mobileNo} disabled />
                </TawreedFormField>

                <TawreedFormField className="field col-12" name="address" title="lbl_partners_address_address">
                    <TawreedInputText render="standalone" placeholder={props.initial?.address?.address}  value={props.initial?.address?.address} disabled />
                </TawreedFormField>
                {/* {props.initial && props.initial.files && <PartnerFiles render="standalone" partnerType={props.initial.partnerType!} businessType={props.initial.businessType!} value={props.initial.files} disabled />} */}
            </div>
        </Panel>
    );
}
